// Auto-generated by scripts/generate-build-info.mjs. Do not edit.
export const buildInfo = {
    commit: '6032c3a',
    builtAt: '2026-08-21T10:51:43.646Z',
} as const;
